import getApi from '../../api'

export const updateDefaultMessageTemplate = (id: number | null) =>
  getApi().put<void>(`/message_templates/default`, { id })
